import React, { useState } from "react";
import "./sidebutton.css";
import { FaEnvelope, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import ContactForm from "../ContactForm/ContactForm";


function SideButtons() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* ===== FLOATING ICONS ===== */}
      <div className="side-buttons">

        {/* Contact Us */}
        <div className="btn red" onClick={() => setOpen(true)}>
          <FaEnvelope /> Contact Us
        </div>

        {/* Call */}
        <a href="tel:9444678233" className="btn black">
          <FaPhoneAlt />
        </a>

        {/* WhatsApp */}
        <a
          href="https://wa.me/9444678233"
          target="_blank"
          rel="noopener noreferrer"
          className="btn green"
        >
          <FaWhatsapp />
        </a>
      </div>

      {/* ===== POPUP FORM ===== */}
      {open && <ContactForm close={() => setOpen(false)} />}
    </>
  );
}

export default SideButtons;
